// @ts-ignore svg import
import CarouselCreditsUsage from 'bender-url!pricing-pages-ui-components/js/hsocImages/carousel_credits_usage_dashboard.svg';
// @ts-ignore svg import
import CarouselSalesProspecting from 'bender-url!pricing-pages-ui-components/js/hsocImages/carousel_sales_prospecting_agent.svg';
// @ts-ignore svg import
import CarouselSmartProperties from 'bender-url!pricing-pages-ui-components/js/hsocImages/carousel_smart_properties.svg';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { HR } from 'foundations-components/transitional/components/HR';
import { Image } from 'foundations-components/transitional/components/Image';
import styled, { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import LinkWrapper from '../components/LinkWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CardContainer = styled.div.withConfig({
  displayName: "AIAgentCard__CardContainer"
})({
  position: 'relative',
  minHeight: '583px',
  display: 'flex',
  flexDirection: 'column'
});
const BadgePill = props => {
  const theme = useTheme();
  const isCanvas = isCanvasTheme(theme);
  return /*#__PURE__*/_jsx(View, Object.assign({
    position: "absolute",
    insetBlockStart: `-${theme.space[400]}`,
    insetInlineStart: theme.space[600],
    zIndex: 1,
    "data-style": "bg-orange-05",
    backgroundColor: isCanvas ? 'fill-accent-light-orange-hover' : 'fill-accent-orange-subtle',
    borderRadius: "full",
    paddingBlock: "0",
    paddingInline: "300"
  }, props));
};
const AGENT_IMAGES = {
  customer: CarouselCreditsUsage,
  prospecting: CarouselSalesProspecting,
  data: CarouselSmartProperties
};
const AGENT_URLS = {
  customer: 'https://www.hubspot.com/products/artificial-intelligence/ai-customer-service-agent',
  prospecting: 'https://www.hubspot.com/products/sales/ai-prospecting-agent',
  data: 'https://www.hubspot.com/products/artificial-intelligence/ai-data-agent'
};
const Prefix = ({
  children
}) => /*#__PURE__*/_jsx(Text, {
  as: "span",
  "data-typography": "p-sm",
  children: children
});
const AgentCardLayout = ({
  title,
  description,
  altText,
  image,
  stat1Percentage,
  stat1Text,
  stat2Percentage,
  stat2Text
}) => {
  return /*#__PURE__*/_jsxs(CardContainer, {
    children: [/*#__PURE__*/_jsx(BadgePill, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        "data-typography": "microcopy",
        typography: "heading-25",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hsocCreditsExplainer.aiAgents.badge"
        })
      })
    }), /*#__PURE__*/_jsxs(CardWrapper, {
      justifySelf: "stretch",
      borderColor: "border-core-subtle",
      borderWidth: "100",
      borderStyle: "solid",
      borderRadius: "400",
      padding: "800",
      marginBlockEnd: "0",
      paddingBlockStart: "800",
      flex: "1",
      display: "flex",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsxs(CardSection, {
        padding: "0",
        flex: "1",
        display: "flex",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsxs(View, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h3",
            "data-typography": "h5",
            typography: "heading-400",
            children: title
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            marginBlockStart: "200",
            "data-typography": "p-sm",
            children: description
          })]
        }), /*#__PURE__*/_jsx(Flex, {
          flex: "1",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          children: /*#__PURE__*/_jsx(Image, {
            paddingInlineStart: "600",
            src: image,
            alt: altText
          })
        }), /*#__PURE__*/_jsx(HR, {
          marginBlock: "0"
        })]
      }), /*#__PURE__*/_jsx(CardSection, {
        padding: "0",
        marginBlockStart: "600",
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          gap: "400",
          children: [/*#__PURE__*/_jsxs(View, {
            flex: 1,
            textAlign: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "p",
              "data-typography": "d1",
              typography: "heading-600",
              color: "fill-brand-default",
              "data-style": "font-family-serif",
              children: stat1Percentage
            }), /*#__PURE__*/_jsx(Text, {
              as: "p",
              marginBlockStart: "200",
              "data-typography": "p-sm",
              typography: "detail-200",
              children: stat1Text
            })]
          }), /*#__PURE__*/_jsx(View, {
            inlineSize: "1px",
            blockSize: "80px",
            backgroundColor: "border-core-subtle"
          }), /*#__PURE__*/_jsxs(View, {
            flex: 1,
            textAlign: "center",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "p",
              "data-typography": "d1",
              typography: "heading-600",
              color: "fill-brand-default",
              "data-style": "font-family-serif",
              children: stat2Percentage
            }), /*#__PURE__*/_jsx(Text, {
              as: "p",
              marginBlockStart: "200",
              "data-typography": "p-sm",
              typography: "detail-200",
              children: stat2Text
            })]
          })]
        })
      })]
    })]
  });
};
const AIAgentCard = ({
  agent,
  onLinkClick
}) => {
  const handleLearnMoreClick = agentType => {
    onLinkClick === null || onLinkClick === void 0 || onLinkClick({
      type: 'external',
      url: AGENT_URLS[agentType],
      name: `${agentType}-agent-learn-more`
    });
  };
  if (agent === 'customer') {
    return /*#__PURE__*/_jsx(AgentCardLayout, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocCreditsExplainer.aiAgents.customer.title"
      }),
      description: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "hsocCreditsExplainer.aiAgents.customer.description",
        options: {
          learnMoreLink: /*#__PURE__*/_jsx(LinkWrapper, {
            href: AGENT_URLS.customer,
            external: true,
            onClick: () => handleLearnMoreClick('customer'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "hsocCreditsExplainer.aiAgents.learnMore"
            })
          })
        }
      }),
      altText: I18n.text('hsocCreditsExplainer.aiAgents.customer.title'),
      image: AGENT_IMAGES.customer,
      stat1Percentage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocCreditsExplainer.aiAgents.customer.stats.stat1.percentage"
      }),
      stat1Text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocCreditsExplainer.aiAgents.customer.stats.stat1.text"
      }),
      stat2Percentage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocCreditsExplainer.aiAgents.customer.stats.stat2.percentage"
      }),
      stat2Text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocCreditsExplainer.aiAgents.customer.stats.stat2.text"
      })
    });
  }
  if (agent === 'prospecting') {
    return /*#__PURE__*/_jsx(AgentCardLayout, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocCreditsExplainer.aiAgents.prospecting.title"
      }),
      description: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "hsocCreditsExplainer.aiAgents.prospecting.description",
        options: {
          learnMoreLink: /*#__PURE__*/_jsx(LinkWrapper, {
            href: AGENT_URLS.prospecting,
            external: true,
            onClick: () => handleLearnMoreClick('prospecting'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "hsocCreditsExplainer.aiAgents.learnMore"
            })
          })
        }
      }),
      altText: I18n.text('hsocCreditsExplainer.aiAgents.prospecting.title'),
      image: AGENT_IMAGES.prospecting,
      stat1Percentage: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "hsocCreditsExplainer.aiAgents.prospecting.stats.stat1.percentage_jsx",
        elements: {
          Prefix
        }
      }),
      stat1Text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocCreditsExplainer.aiAgents.prospecting.stats.stat1.text"
      }),
      stat2Percentage: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "hsocCreditsExplainer.aiAgents.prospecting.stats.stat2.percentage_jsx",
        elements: {
          Prefix
        }
      }),
      stat2Text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hsocCreditsExplainer.aiAgents.prospecting.stats.stat2.text"
      })
    });
  }
  return /*#__PURE__*/_jsx(AgentCardLayout, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocCreditsExplainer.aiAgents.data.title"
    }),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "hsocCreditsExplainer.aiAgents.data.description",
      options: {
        learnMoreLink: /*#__PURE__*/_jsx(LinkWrapper, {
          href: AGENT_URLS.data,
          external: true,
          onClick: () => handleLearnMoreClick('data'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "hsocCreditsExplainer.aiAgents.learnMore"
          })
        })
      }
    }),
    altText: I18n.text('hsocCreditsExplainer.aiAgents.data.title'),
    image: AGENT_IMAGES.data,
    stat1Percentage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocCreditsExplainer.aiAgents.data.stats.stat1.percentage"
    }),
    stat1Text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocCreditsExplainer.aiAgents.data.stats.stat1.text"
    }),
    stat2Percentage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocCreditsExplainer.aiAgents.data.stats.stat2.percentage"
    }),
    stat2Text: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hsocCreditsExplainer.aiAgents.data.stats.stat2.text"
    })
  });
};
export default AIAgentCard;